import FacilityPageHeader from './FacilityPageHeader';

export default FacilityPageHeader;
